import { render, staticRenderFns } from "./GeneralDialog.vue?vue&type=template&id=0f0746c2&scoped=true"
import script from "./GeneralDialog.vue?vue&type=script&lang=js"
export * from "./GeneralDialog.vue?vue&type=script&lang=js"
import style0 from "./GeneralDialog.vue?vue&type=style&index=0&id=0f0746c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0746c2",
  null
  
)

export default component.exports